import React from "react";
import { Select } from "antd";
import bankData from "@constant/bank.json";

type Props = {
  value?: any;
  onChange?: (params: any) => void;
  onBankCodeChange?: (bankCode: number) => void; // 額外 side effect
  disabled?: boolean;
};

const BankList = (props: Props) => {
  const { value, onChange, onBankCodeChange, disabled } = props;
  const triggerChange = (bankCode: number) => {
    if (onChange) {
      onChange(bankCode);
      onBankCodeChange?.(bankCode);
    }
  };

  const headBankName = bankData
    .filter((item) => !item.branchCode)
    .map((item) => ({
      bankName: item.bankName,
      bankCode: item.bankCode,
    }))
    .map((info: { bankCode: string; bankName: string }) => ({
      value: info.bankCode,
      label: info.bankName,
    }));

  return (
    <Select
      showSearch
      value={value}
      style={{ width: "100%" }}
      onChange={triggerChange}
      filterOption={(input, option: any) => option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      placeholder="請選擇"
      options={headBankName}
      disabled={disabled}
    />
  );
};

export default BankList;
